export default __webpack_public_path__ + "static/media/top-header.4949f14f.png";